<template>
  <div class="bodyTable">
    <v-data-table
      v-model="selected"
      color="blue lighten-4"
      item-key="codiceRiga"
      :headers="headers"
      :items="righeLotto"
      :options.sync="options"
      :server-items-length="totaleRighe"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100]
      }"
      dense
      calculate-widths
    > 
<!--       <template v-slot:[`item.updown`]="{ index }">
        <v-icon v-if="index !== 0" dense title="Sposta in alto">mdi-arrow-up-bold-outline</v-icon>

      </template>      -->
      <template v-slot:[`item.rigaDescrittiva`]="{ item, index }">
        <component :is="'pSwitch'" :item="itemRigaDescrittiva(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="disableRigaDescrittiva(item)" :updateTrigger="updateTrigger"/>
      </template>      
      <template v-slot:[`item.codice`]="{ item, index }">
        <component :is="'pProdotto'"  v-if="!item.rigaDescrittiva" :item="itemCodice(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true" :isLotto="true" :isProdottoBase="true"/>
      </template>       
      <template v-slot:[`item.descrizione`]="{ item, index }">
        {{ (item.rigaIndentata ? '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' : '') }}<component :is="'pTesto'" :item="itemDescrizione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>
      <template v-slot:[`item.quantita`]="{ item, index }">
        <component :is="'pTesto'" :item="itemQuantita(item)" :ref="`quantita_${index}`" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>
      <template v-slot:[`item.unitaMisura`]="{ item, index }">
        <component :is="'pMultiselect'" :item="itemUnitaMisura(item)" :index="index" :disableClear="true" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>
<!--       <template v-slot:[`item.listino`]="{ item, index }">
        <component :is="'pMultiselect'" :item="itemListino(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template> -->
<!--       <template v-slot:[`item.aliquota`]="{ item, index }">
        <component :is="'pMultiselect'" :item="itemAliquota(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template> -->
<!--       <template v-slot:[`item.appoggio.prodotto.acquistoFornitore`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getUltimoAcquisto(item, true) | euro"/>
      </template> -->
      <template v-slot:[`item.valore.prezzoNettoUnitario`]="{ item, index }">
        <component :is="'pTesto'" :textClass="'text-align-center'" :item="itemPrezzoNetto(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template>      
<!--       <template v-slot:[`item.appoggio.prodotto.acquisto`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" class="text-caption" readonly :value="getUltimoAcquisto(item, false)"/>
      </template>     -->    
      <template v-slot:[`item.valore.prezzoNettoTotale`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto"  /> <!-- mancano i valori, rimettere -->
      </template>
      <template v-slot:[`item.custom.fornitore`]="{ item, index }">
        <component :is="'pTesto'" :item="itemLottoFornitore(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        <!-- <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto"  /> -->
      </template>
      <template v-slot:[`item.custom.produzione`]="{ item, index }">
        <!-- <component :is="'pData'" :textClass="'text-align-center'" :item="itemLottoProduzione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/> -->
        <!-- <component :is="'pTesto'" :item="itemLottoProduzione(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/> -->
        <component :is="'pData'" :item="itemLottoProduzione(item)" :index="index" :appoggio="item.appoggio" :outlined="false" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        <!-- <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto"  /> -->
      </template>
      <template v-if="mostraDataScadenza" v-slot:[`item.custom.scadenza`]="{ item, index }">
        <component :is="'pData'" :item="itemLottoScadenza(item)" :index="index" :appoggio="item.appoggio" :outlined="false" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        <!-- <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto"  /> -->
      </template>
<!--       <template v-slot:[`item.custom.info`]="{ item, index }">
        <component :is="'pTesto'" :item="itemLottoInfo(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
      </template> -->
      <template v-slot:[`item.custom.riferimento`]="{ item,index }">
        <component :is="'pTesto'" :item="itemLottoRiferimento(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :suTable="true"/>
        <!-- <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto"  /> -->
      </template>
      <template v-slot:[`item.appoggio.importoTotale`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getImportoTotale(item) | euro"/>
      </template>
<!--       <template v-slot:[`item.valore.importoNettoTotale`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="item.valore.importoNettoTotale | euro"/>
      </template> -->
<!--       <template v-slot:[`item.valore.prezzoNettoUnitario`]="{ item }">
        <v-text-field v-if="!item.rigaDescrittiva" dense solo flat hide-details="auto" readonly :value="getIva(item) | euro"/>
      </template>  -->
      <template v-slot:[`item.actions`]="{ item, index }">
        <v-icon small class="mr-2" @click="dettaglioLottoItem(item, index)" title="Dettaglio lotto">mdi-clipboard-text-outline</v-icon>
        <v-icon small @click="deleteItem(item)" title="Cancella la riga">mdi-delete</v-icon>
        <v-menu :offset-x="true" left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-2" v-bind="attrs" v-on="on" title="Azioni aggiuntive">mdi-dots-vertical</v-icon>
          </template>
          <three-dots-menu :item="item" :index="index" :rowsNumber="righeLotto.length" @click="menuClick"/>
        </v-menu>    
<!--         <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon small @click="deleteItem(item)" v-bind="attrs" v-on="on">mdi-delete</v-icon>
          </template>
          <span>Cancella la riga</span>
        </v-tooltip>        --> 
<!--         <v-dialog v-model="dialog" max-width="500px" v-if="!item.rigaDescrittiva" :retain-focus="false">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small class="ml-3 mr-0" v-bind="attrs" v-on="on" title="Modifica prezzi e sconti">mdi-calculator</v-icon>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Sconti e importi</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemPrezzi(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                  </v-col>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemSconti(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger" :lockValori="!aggiornaSconti ? 1 : 2" @toggleLock="toggleLock"/>
                  </v-col>
                  <v-col cols="12">
                    <component :is="'pQuattroValori'" :item="itemImporti(item)" :index="index" :appoggio="item.appoggio" @change="componentValueChange" :disabled="readOnly" :updateTrigger="updateTrigger"/>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click.stop="dialogClose">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog> -->
      </template>
      <template v-slot:[`foot`]>
        <v-btn class="text-right" @click="onNuovaRiga" v-if="nuovaRigaAbilitata">Nuova riga</v-btn>
      </template>
<!--       <template v-slot:[`footer.prepend`]>
        <v-btn color="success" @click="onMostraParcheggio" v-if="nuovaRigaAbilitata">Importa da Park</v-btn>
      </template> -->
    </v-data-table>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Confermi cancellazione riga ?</v-card-title>
        <v-card-text>{{dettaglioRiga}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="deleteItemConfirm">SI</v-btn>
          <v-btn color="blue darken-1" text @click="closeDelete">NO</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-storico :show="dialogStorico" :prodotto="prodottoStorico"/>
    <dialog-lotto :show="dialogLotto" :prodotto="prodottoLotto" @save="salvaDettaglioLotto"/>
  </div>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import prodotti from '@/services/prodottiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import pProdotto from '../../elementi/prodotto'
  import pSwitch from '../../elementi/switch'
  import pTesto from '../../elementi/testo'
  import pData from '../../elementi/data'
  import pMultiselect from '../../elementi/multiselect'
  import ThreeDotsMenu from '../../elementiBody/threeDotsMenu'
  import DialogStorico from '../../elementiBody/dialogStorico'
  import DialogLotto from './dialogLotto'

  export default {
    components: {
      pProdotto,
      pSwitch,
      pTesto,
      pData,
      pMultiselect,
      ThreeDotsMenu,
      DialogStorico,
      DialogLotto
      // pQuattroValori
    },
    props: {
      locLotto: Object,
      trigger: { type: Number, default: 1}
    },
    data () {
      return {
        selected: [],
        loading: false,
        options: {},
        headers01: [
          { text: 'Descrittiva', value:'rigaDescrittiva', width: 30 }, 
          { text: 'Codice', value: 'codice', align: 'start', width: '10%'},
          { text: 'Descrizione', value: 'descrizione', width: '20%' },
          { text: 'Quantità', value: 'quantita', align: 'start', width: '5%' },
          { text: 'UM', value: 'unitaMisura', align: 'start', width: '4%' },
          { text: 'Prezzo', value: 'valore.prezzoNettoUnitario', align: 'start'},
          { text: 'Lotto Fornitore', value: 'custom.fornitore', align: 'start'},
          { text: 'Data Produzione', value: 'custom.produzione', align: 'start'},
          { text: '', value: '', align: 'start', width: 3 }
        ],
        headers02: [
          { text: 'Data Scadenza', value: 'custom.scadenza', align: 'start'}
        ],
        headers03: [
          { text: 'Riferimento', value: 'custom.riferimento', align: 'start'},
          { text: 'Importo Totale', value: 'appoggio.importoTotale' , align: 'start'},
          { text: 'Actions', value: 'actions', sortable: false }
        ],
        expanded: [],
        singleExpand: false,
        dialog: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
/*         defaultItem: null,
        modelloLotto: null, */
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        // impostazioniEtichette: null,
        usaQtaAnagrafica: false, // TODO: da configurazioni
        salta: 0,
        filtroElementi: null,
        tipoStampa: '',
        report: '',
        erroreLotto: '',
        updateTrigger: 1,
        readOnly: false, // eventualmente su computed,
        locRigaLotto: null,
        rigaModello: {
          rigaDescrittiva: false,
          codice: '',
          descrizione: '',
          quantita: '',
          unitaMisura: '',
          listino: null,
          aliquota: null,
          prezzi: null,
          sconti: null,
          importi: null
        },
        aggiornaSconti: true, // da impostazioni scelgo se aggiornare gli sconti o il prezzo di listino nel caso di modifica dell'importo
        dialogStorico: false,
        prodottoStorico: null,
        mostraParcheggio: false,
        dialogLotto: false,
        prodottoLotto: null,
        mostraDataScadenza: true
      }
    },
    computed: {
      righeLotto() {
        return _.get(this, 'locLotto.righe', [])
      },
      totaleRighe() {
        return this.righeLotto.length
      },
      nuovaRigaAbilitata() {
        return this.trigger && this.locLotto.anagrafica
      },
      dettaglioRiga() {
        let riga = this.editedIndex
        if (riga === -1) return
        let ed = this.righeLotto[riga]
        if (!ed) return ''
        return ed.descrizione.trim()
      },
      headers() {
        let hd = this.headers01
        if (this.mostraDataScadenza) {
          hd = hd.concat(this.headers02)
        }
        hd = hd.concat(this.headers03)
        return hd
      }
    },
    watch: {
      options: {
        async handler () {
          // await this.getDataFromApi()
        },
        deep: true
      },
      dialog (val) {
        val || this.dialogClose()
      },     
      dialogDelete (val) {
        val || this.closeDelete()
      }
    },
    async mounted () {
      const backoffice = await configurazioni.getConfigurazione('backoffice')
      this.mostraDataScadenza = _.get(backoffice, 'impostazioni.lotti.acquisto.mostraDataScadenza', true)

      this.$root.$on('aggiungiProdotti', this.onAggiungiProdotti)
    },
    methods: {
      salvaDettaglioLotto(lotto) {
        //  this.locLotto.custom = lotto
        this.updateTrigger++
      },
      async dettaglioLottoItem(item, index) {
        item.custom = item.custom || {}
        item.custom.carne = item.custom.carne || {}
        this.prodottoLotto = item
        this.dialogLotto = true
        await this.$nextTick()
        this.dialogLotto = false
      },
      async onAggiungiProdotti(righe) {
        for (let riga of righe) {
          const idProdotto = riga.codice
          const p = await prodotti.getProdotto(idProdotto)
          let nr = JSON.parse(JSON.stringify(this.rigaModello))
          nr.valore = nr.valore || {}
          nr.valore.listino = this.locLotto.appoggio.clifor.amministrativi.listino
          nr.valore = { ...nr.valore, ...this.locLotto.appoggio.clifor.amministrativi.sconti }
          _.set(nr, 'appoggio.prodotto', p)
          _.set(nr, 'prodotto.codice', idProdotto)
          this.$emit('nuovaRiga', nr) // verificare se a questo livello o alla fine, dopo aver aggiunto il prodotto
          await this.$nextTick()
          const index = this.locLotto.righe.length - 1
          let data = {
            model: 'prodotto.codice',
            subModel: null,
            value: p._id,
            item: p,
            index: index
          }
          await this.componentValueChange(data)
          data = {
            model: 'quantita',
            decimals: 2,
            subModel: null,
            value: riga.quantita,
            item: null,
            index: index
          }
          await this.componentValueChange(data)
        }
        await this.$nextTick()
        this.mostraParcheggio = false
        this.$emit('mostraParcheggio', false)
      },
      onMostraParcheggio() {
        this.mostraParcheggio = !this.mostraParcheggio
        this.$emit('mostraParcheggio', this.mostraParcheggio)
      },
      async menuClick({ command, index }) {
        switch(command) {
          case 'utility_storico':
            this.dialogStorico = true
            this.prodottoStorico = this.locLotto.righe[index]
            await this.$nextTick()
            this.dialogStorico = false
            break
          case 'move_top':
            this.$emit('move', index, 0)
            break
          case 'move_bottom':
            this.$emit('move', index, -1)
            break
          case 'move_up':
            this.$emit('move', index, index - 1)
            break
          case 'move_down':
            this.$emit('move', index, index + 1)
            break
          default:
            break
        }
      },
      disableRigaDescrittiva(item) {
        const isProdotto = item.prodotto && item.prodotto.codice.length > 0 ? true : false
        const isQuantita = item.quantita && parseFloat(item.quantita) > 0 ? true : false
        return this.readOnly || isProdotto || isQuantita
      },      
      toggleLock() {
        this.aggiornaSconti = !this.aggiornaSconti
      },
      dialogClose () {
        this.dialog = false
        this.$nextTick(() => {
/*           this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1 */
        })
      },
      getSconto(item) {
        return +(parseFloat(item.valore.prezzoTotale) - parseFloat(item.valore.importoTotale)).toFixed(2)
      },
      getIva(item) {
        return +(parseFloat(item.valore.importoTotale) - parseFloat(item.valore.importoNettoTotale)).toFixed(2)
      },
      getUltimoAcquisto(item, fornitore) {
        if (fornitore) {
          // Ritorna il prezzo di acquisto dal fornitore scelto per l'ordine
          const fo = _.get(this.locLotto, 'anagrafica.fornitore', null)
          const ff = _.get(item, 'appoggio.prodotto.item.fornitori', [])
          const f = fo && ff.find(x => x.codice === fo.codice)
          if (f) {
            return f.prezzo
          } else {
            return _.get(item, 'appoggio.prodotto.acquisto', 0) || _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '')
          }
        } else {
          // Ritorna i dati dell'ultimo acquisto effettuato, anche se da fornitore diverso
          const ua = _.get(item, 'appoggio.prodotto.item.ultimoAcquisto', null)
          return _.get(ua,'fornitoreDescrizione', false) ? `${ua.fornitoreDescrizione} @ ${this.$options.filters.date(ua.data)} ( ${ua.quantita} : ${this.$options.filters.euro(ua.prezzo)} )` : ''
          // return _.get(item, 'appoggio.prodotto.item.ultimoAcquisto.prezzo', '')
        }
      },
      getImportoTotale(item) {
        const pz = item.valore.prezzoNettoUnitario || this.getUltimoAcquisto(item, true)
        const qta = item.quantita || 0
        return qta ? +(pz * qta).toFixed(2) : ''
      },
      itemRigaDescrittiva(item) {
        return  {
          "model": "rigaDescrittiva",
          "valueField": "rigaDescrittiva",
          "type": "Switch",
          "label": "",
          value: _.get(item, 'rigaDescrittiva', false)
        }
      },
      itemCodice(item) {
        return {
          "model": "prodotto.codice",
          "valueField": "prodotto.codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "prodotto.descrizione",
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          "cercaEsterno": true,
          value: _.get(item, 'prodotto.codice', '')          
        }
      },
      itemDescrizione(item) {
        return {
          "model": "descrizione",
          "valueField": "descrizione",
          "label": "Descrizione",
          "type": "TextArea",
          "required": true,
          value: _.get(item, 'descrizione', '') 
        }
      },
      itemQuantita(item) {
        return {
          "model": "quantita",
          "valueField": "quantita",
          "label": "Quantità",
          "type": "Testo",
          "required": false,
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'quantita', '') 
        }
      },
      itemLottoProduzione(item) {
        return {
          "model": "custom.produzione",
          "valueField": "custom.produzione",
          "label": "",
          "type": "Data",
          "required": false,
          "hideIf": "appoggio.rigaDescrittiva",
          value: item.custom ? item.custom.produzione : '' // _.get(item, 'custom.produzione', '')           
        }
      },
      itemLottoScadenza(item) {
        return {
          "model": "custom.scadenza",
          "valueField": "custom.scadenza",
          "label": "",
          "type": "Data",
          "required": false,
          "hideIf": "appoggio.rigaDescrittiva",
          value: item.custom && item.custom.scadenza ? item.custom.scadenza : (this.locLotto && this.locLotto.custom ? this.locLotto.custom.scadenza : '') // _.get(item, 'custom.scadenza', '')           
        }
      },      
      itemLottoFornitore(item) {
        return {
          "model": "custom.fornitore",
          "valueField": "custom.fornitore",
          "label": "Lotto fornitore",
          "type": "Testo",
          "required": false,
          value: item.custom ? item.custom.fornitore : '' // _.get(item, 'custom.fornitore', '') 
        }
      },
/*       itemLottoInfo(item) {
        return {
          "model": "custom.info",
          "valueField": "custom.info",
          "label": "Informazioni",
          "type": "TextArea",
          "required": false,
          value: item.custom ? item.custom.info : '' // _.get(item, 'custom.info', '') 
        }
      }, */
      itemLottoRiferimento(item) {
        return {
          "model": "custom.riferimento",
          "valueField": "custom.riferimento",
          "label": "Riferimento",
          "type": "Testo",
          "required": false,
          value: item.custom ? item.custom.riferimento : '' // _.get(item, 'custom.riferimento', '')
        }
      },  
      itemUnitaMisura(item) {
        return {
          "model": "unitaMisura",
          "valueField": "unitaMisura",
          "type": "Multiselect",
          "label": "UM",
          "source": "prodotti_unita_misura.um",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'unitaMisura', '') 
        }
      },
	    itemOrdinePrezzo(item) {
        return {
          "model": "ordine.prezzo",
          "valueField": "ordine.prezzo",
          "label": "",
          "type": "Testo",
          "required": false,
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'ordine.prezzo', '') ||  _.get(item, 'ordine.prezzoUnitario', '') 
        }
      },      
      itemListino(item) {
        return {
          "model": "valore.listino",
          "valueField": "valore.listino",
          "type": "Multiselect",
          "label": "Listino",
          "source": "listini.listini",
          "required": true,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'valore.listino', '') 
        }
      },
      itemPrezzoNetto(item) {
        return {
          "model": "valore.prezzoNettoUnitario",
          "valueField": "valore.prezzoNettoUnitario",
          "label": "",
          "type": "Testo",
          "required": false,
          "numerico": true,
          "decimals": 2,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'valore.prezzoNettoUnitario', '') || 0
        }
      },      
      
      itemAliquota(item) {
        return {
          "model": "appoggio.aliquotaIva",
          "valueField": "appoggio.aliquotaIva",
          "type": "Multiselect",
          "label": "Aliquota Iva",
          "source": "prodotti_aliquote_iva.aliquote",
          "required": false,
          "readOnly": true,
          "addForbidden": true,
          "hideIf": "appoggio.rigaDescrittiva",
          value: _.get(item, 'aliquotaIva', '') 
        }
      },
      itemPrezzi(item) {
        return {
          "label": "Prezzi",
          "model1": "valore.prezzoNettoUnitario",
          "valueField1": "valore.prezzoNettoUnitario",
          "label1": "netto unitario",
          "classTestCondition1": "appoggio.listino.nonIvato",
          "classIfCondition1": "font-weight-black",
          "model2": "valore.prezzoNettoTotale",
          "valueField2": "valore.prezzoNettoTotale",
          "label2": "netto totale",
          "classTestCondition2": "appoggio.listino.nonIvato",
          "classIfCondition2": "font-weight-black",
          "model3": "valore.prezzoUnitario",
          "valueField3": "valore.prezzoUnitario",
          "label3": "unitario",
          "classTestCondition3": "appoggio.listino.ivato",
          "classIfCondition3": "font-weight-black",
          "model4": "valore.prezzoTotale",
          "valueField4": "valore.prezzoTotale",
          "label4": "totale",
          "classTestCondition4": "appoggio.listino.ivato",
          "classIfCondition4": "font-weight-black",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.prezzoNettoUnitario', ''),
          value2: _.get(item, 'valore.prezzoNettoTotale', ''),
          value3: _.get(item, 'valore.prezzoUnitario', ''),
          value4: _.get(item, 'valore.prezzoTotale', '')
        }
      },
      itemSconti(item) {
        return {
          "label": "Sconti",
          "model1": "valore.sconto1",
          "valueField1": "valore.sconto1",
          "label1": "sconto 1",
          "model2": "valore.sconto2",
          "valueField2": "valore.sconto2",
          "label2": "sconto 2",
          "model3": "valore.sconto3",
          "valueField3": "valore.sconto3",
          "label3": "sconto 3",
          "model4": "valore.sconto4",
          "valueField4": "valore.sconto4",
          "label4": "sconto 4",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.sconto1', ''),
          value2: _.get(item, 'valore.sconto2', ''),
          value3: _.get(item, 'valore.sconto3', ''),
          value4: _.get(item, 'valore.sconto4', '')      
        }
      },
      itemImporti(item) {
        return       {
          "label": "Importi",
          "model1": "valore.importoNettoUnitario",
          "valueField1": "valore.importoNettoUnitario",
          "label1": "netto unitario",
          "model2": "valore.importoNettoTotale",
          "valueField2": "valore.importoNettoTotale",
          "label2": "netto totale",
          "model3": "valore.importoUnitario",
          "valueField3": "valore.importoUnitario",
          "label3": "unitario",
          "model4": "valore.importoTotale",
          "valueField4": "valore.importoTotale",
          "label4": "totale",
          "type": "QuattroValori",
          "required": false,
          "numerico": true,
          "decimals": 2,
          value1: _.get(item, 'valore.importoNettoUnitario', ''),
          value2: _.get(item, 'valore.importoNettoTotale', ''),
          value3: _.get(item, 'valore.importoUnitario', ''),
          value4: _.get(item, 'valore.importoTotale', '')
        }
      },       
      rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      },
      async onNuovaRiga() {
        const nr = JSON.parse(JSON.stringify(this.rigaModello))
        nr.valore = nr.valore || {}
        nr.valore.listino = this.locLotto.appoggio.clifor.amministrativi.listino
        nr.valore = { ...nr.valore, ...this.locLotto.appoggio.clifor.amministrativi.sconti }
        nr.appoggio = nr.appoggio || {} 
        this.$emit('nuovaRiga', nr)
      },
      async editItem (item) {
/*         this.editedIndex = this.righeLotto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.completaAppoggio()
        this.$store.commit('lottiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      duplicateItem(item) {
/*         this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        this.$store.commit('lottiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', false)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      deleteItem (item) {
        this.editedIndex = this.righeLotto.indexOf(item)
        this.dialogDelete = true
/*         this.editedIndex = this.righeLotto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true */
      },
      async deleteItemConfirm () {
        this.righeLotto.splice(this.editedIndex, 1)
        // Verificare in base al tipo lotto se va aggiornata la giacenza
        // Nel caso fare un movimento di rettifica
/*         if (this.locLotto._id) {
          await prodotti.aggiornaDeltaGiacenza(
            this.editedItem.items.prodotto._id,
            this.editedItem.items.custom.magazzino,
            -this.editedItem.items.custom.quantita
          )
        } */
        this.closeDelete()
        this.editedIndex = -1
        this.$emit('updateTotali')
      },

      close () {
        this.dialog = false
/*         this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        }) */
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          // this.editedItem = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      async save () {
/*         this.$store.commit('lottiDettaglio/CLEAR_RIGA_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['lottiDettaglio/rigaLotto']
        let lotto = await lotti.getLotto(this.chiaveLotto._id)
        if (this.editedIndex > -1) {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          Object.assign(this.righeLotto[this.editedIndex], this.editedItem)
          Object.assign(custom.righe[this.editedIndex], this.editedItem)
        } else {
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)        
          this.righeLotto.push(this.editedItem)
          custom.righe = custom.righe || []
          custom.righe.push(this.editedItem)
        }
        if (!await lotti.aggiornaLotto(lotto)) {
          this.dialogErrore = true
          return
        }
        this.close()
        this.$store.commit('lottiDettaglio/CLEAR_RIGA_DOCUMENTO')
        await this.getDataFromApi() */
      },      
      erroreConfirm() {
        this.dialogErrore = false
        this.erroreLotto = ''
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
/*         const item = options.item
        this.editedIndex = this.righeLotto.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('lottiDettaglio/SET_RIGA_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
/*       datiVisualizzazione(lotti) {
        const elaborati = lotti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)
          return { ...el, c_nominativo: nominativo }
        }) 
        return elaborati
      },
      deleteDatiVisualizzazione(lotto) {
        let locLotto = {...lotto}
        delete locLotto.c_nominativo
        delete locLotto.appoggio
        return locLotto
      }, */
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      },
      async componentValueChange(data) {
        const { model, subModel, value, decimals, index } = data
        this.locRigaLotto = this.righeLotto[index]
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.locRigaLotto, tgt)
        await this.aggiornaCorrelati(data)
        // this.$store.commit('lottiDettaglio/SET_RIGA_DOCUMENTO', this.locRigaLotto) // verificare se va fatta store_temp
      },
      async aggiornaCorrelati(data) {
        this.locRigaLotto.appoggio = this.locRigaLotto.appoggio || {}
        let tipoModifica = ''
        switch (data.model) {
          case 'prodotto.codice':
            if (!data.value) {
              delete this.locRigaLotto.appoggio.prodotto
              delete this.locRigaLotto.prodotto
              _.set(this.locRigaLotto, 'valore.prezzoUnitario', 0)   
              this.locRigaLotto.descrizione = ''
            } else {
              this.locRigaLotto.appoggio.prodotto = data.item
              this.locRigaLotto.descrizione = (`${data.item.descrizione} ${_.get(data.item, 'variante2.descrizione', '')} ${_.get(data.item, 'variante1.descrizione', '')}`).trim()
              if (this.locRigaLotto.appoggio.importiModificati) { // La prima volta, devo rileggere il prodotto ma non impostare il listino. Se cambio prodotto, si
                this.locRigaLotto.appoggio.importiModificati = false
                this.updateTrigger++
                return
              }
              this.locRigaLotto.tipoBene = data.item.tipoBene || data.item.item.tipoBene
              this.locRigaLotto.repartoFiscale = data.item.datiFiscali.reparto.stampante
              this.locRigaLotto.unitaMisura = _.get(data.item, 'magazzino.unitaMisura', _.get(data.item, 'item.magazzino.unitaMisura', ''))
              this.locRigaLotto.aliquotaIva = data.item.datiFiscali.aliquoteIva[0]
              this.locRigaLotto.base = data.value
              await this.$nextTick()
              const ref = this.$refs[`quantita_${data.index}`]
              const input = ref.$el.querySelector('input:not([type=hidden]),textarea:not([type=hidden])')
              if (input) {
                setTimeout(() => {
                  input.focus()
                }, 0)
              }
            }
            break;
          case 'rigaDescrittiva':
            delete this.locRigaLotto.appoggio.prodotto
            delete this.locRigaLotto.prodotto
            _.set(this.locRigaLotto, 'valore.prezzoUnitario', 0)
            _.set(this.locRigaLotto, 'appoggio.rigaDescrittiva', data.value)       
            this.locRigaLotto.descrizione = ''
            break;
          case 'valore.listino':
            _.set(this.locRigaLotto,'appoggio.listino.ivato', _.get(data,'value.ivato', true))
            _.set(this.locRigaLotto,'appoggio.listino.nonIvato', !_.get(data,'value.ivato', true))
            break;
          case 'valore.sconto1':
          case 'valore.sconto2':
          case 'valore.sconto3':
          case 'valore.sconto4':
            this.locRigaLotto.sconti = this.rigaSconti(this.locRigaLotto.valore)
            tipoModifica = data.model
            break;
          case 'valore.prezzoUnitario':          
          case 'valore.prezzoTotale':
          case 'valore.prezzoNettoUnitario':
          case 'valore.prezzoNettoTotale':
          case 'valore.importoUnitario':
          case 'valore.importoTotale':
          case 'valore.importoNettoUnitario':
          case 'valore.importoNettoTotale':
            tipoModifica = data.model
            this.locRigaLotto.valore.importiModificati = true // viene messo su appoggio alla successiva riapertura della riga
            break;        
          case 'appoggio.aliquotaIva':
            this.locRigaLotto.aliquotaIva = this.locRigaLotto.appoggio.aliquotaIva
            this.locRigaLotto.aliquotaIva.valore = this.locRigaLotto.aliquotaIva.aliquota
            break;
          case 'quantita':          
            break;
          default:
            break
        }
        this.aggiornaValori(tipoModifica)
        this.updateTrigger++
        this.$emit('updateTotali')
      },
/*       rigaSconti(v) {
        const sc = []
        v.sconto1 && sc.push (v.sconto1)
        v.sconto2 && sc.push (v.sconto2)
        v.sconto3 && sc.push (v.sconto3)
        v.sconto4 && sc.push (v.sconto4)
        return sc.join('+')
      }, */
      aggiornaValori(tipoModifica) {
        const rd = _.get(this.locRigaLotto,'appoggio.rigaDescrittiva', false)
        const prd = _.get(this.locRigaLotto,'appoggio.prodotto', {})
        const lst = _.get(this.locRigaLotto,'valore.listino.codice', '')
        const ivato = rd ? true : _.get(this.locRigaLotto,'valore.listino.ivato', true) // Verificare come gestire se riga descrittiva
        // TODO: Verificare calcolo prezzo listino
        // let pl = rd ? parseFloat(_.get(this.locRigaLotto,'valore.prezzoUnitario', 0)) : parseFloat(_.get(this.locRigaLotto, 'valore.prezzoNettoUnitario', 0) || _.get(prd, `prezzoItem.${lst}.base`, 0))
        let pl = rd ? parseFloat(_.get(this.locRigaDocumento,'valore.prezzoUnitario', 0)) : parseFloat((ivato ? _.get(this.locRigaLotto, `valore.importoUnitario`, 0) : _.get(this.locRigaLotto, `valore.importoNettoUnitario`, 0)))        

        const qta = parseFloat(_.get(this.locRigaLotto,'quantita', 0))
        let sc1 = parseFloat(_.get(this.locRigaLotto,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaLotto,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaLotto,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaLotto,'valore.sconto4', 0) || '0')
        let sconto = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
        // const iva = _.get(prd,'datiFiscali.aliquoteIva[0]', {})
/*    
        const iva = _.get(this.locRigaLotto,'aliquotaIva.valore', {})
        if (!this.locRigaLotto.aliquotaIva) { // Modifico solo se non ho l'aliquota forzata dal cliente
          this.locRigaLotto.aliquotaIva = iva
        } */
        const aliquota = rd ? '' : (this.locRigaLotto.aliquotaIva && (this.locRigaLotto.aliquotaIva.valore || this.locRigaLotto.aliquotaIva.aliquota)) || 0
        let aggiornaSconti = this.aggiornaSconti
        if (parseFloat(this.locRigaLotto.valore.prezzoUnitario || 0) === 0) {
          // Se prezzo di listino nullo (es reparto o prezzi non inseriti) --> aggiornaSconti = false !!
          aggiornaSconti = false
        }

        this.locRigaLotto.valore.acquisto = _.get(this.locRigaLotto, 'appoggio.prodotto.acquisto', 0)
        if (ivato) {
          switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaLotto.valore.prezzoUnitario)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaLotto.valore.prezzoTotale) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario) * ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaLotto.valore.prezzoNettoTotale) * ( 1 + aliquota / 100) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoUnitario) / sconto
              } else {
                pl = parseFloat(this.locRigaLotto.valore.importoUnitario) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoUnitario || 0)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoTotale) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaLotto.valore.importoTotale) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              } else {
                pl = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                pl = parseFloat(this.locRigaLotto.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
              }
              break; 
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaLotto.valore.prezzoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaLotto.valore.prezzoUnitario) || pl
              break;
          }
/*           this.locRigaLotto.valore.prezzoUnitario = pl ? pl.toFixed(2) : ''
          this.locRigaLotto.valore.prezzoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoUnitario = pl ? (pl / ( 1 + aliquota / 100)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)).toFixed(2) : '' */
          this.locRigaLotto.valore.prezzoUnitario = pl ? pl : ''
          this.locRigaLotto.valore.prezzoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoUnitario = pl ? (pl / ( 1 + aliquota / 100)): ''
          this.locRigaLotto.valore.prezzoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoUnitario = pl ? this.locRigaLotto.valore.prezzoUnitario.toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoUnitario = pl ? this.locRigaLotto.valore.prezzoNettoUnitario.toFixed(2) : ''

/*           this.locRigaLotto.valore.importoUnitario = pl ? (pl * sconto).toFixed(2) : ''
          this.locRigaLotto.valore.importoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoUnitario = pl ? ((pl / ( 1 + aliquota / 100)) * sconto).toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoNettoUnitario)).toFixed(2) : '' */
          this.locRigaLotto.valore.importoUnitario = pl ? (pl * sconto) : ''
          this.locRigaLotto.valore.importoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoUnitario = pl ? ((pl / ( 1 + aliquota / 100)) * sconto) : ''
          this.locRigaLotto.valore.importoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoUnitario = pl ? this.locRigaLotto.valore.importoUnitario.toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoUnitario = pl ? this.locRigaLotto.valore.importoNettoUnitario.toFixed(2) : ''

        } else {
        switch (tipoModifica) {
            case 'valore.prezzoUnitario':
              pl = parseFloat(this.locRigaLotto.valore.prezzoUnitario) / ( 1 + aliquota / 100)
              break;
            case 'valore.prezzoTotale':
              pl = parseFloat(this.locRigaLotto.valore.prezzoTotale) / ( 1 + aliquota / 100) / qta
              break;
            case 'valore.prezzoNettoUnitario':
              pl = parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)
              break;
            case 'valore.prezzoNettoTotale':
              pl = parseFloat(this.locRigaLotto.valore.prezzoNettoTotale) / qta
              break;
            case 'valore.importoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoUnitario) / ( 1 + aliquota / 100) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              } else {
                // pl = parseFloat(this.locRigaLotto.valore.prezzoUnitario) / sconto
                pl = parseFloat(this.locRigaLotto.valore.importoUnitario) / ( 1 + aliquota / 100) / sconto
              }
              break;
            case 'valore.importoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoTotale) / ( 1 + aliquota / 100) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaLotto.valore.importoTotale) / (sconto * qta)
                pl = parseFloat(this.locRigaLotto.valore.importoTotale) / ( 1 + aliquota / 100) / (sconto * qta)
              }
              break;
            case 'valore.importoNettoUnitario':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) / oldPl
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) / sconto
              } else {
                // pl = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) * ( 1 + aliquota / 100) / sconto
                pl = parseFloat(this.locRigaLotto.valore.importoNettoUnitario) / sconto
              }
              break;
            case 'valore.importoNettoTotale':
              if (aggiornaSconti) {
                let oldPl =  parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)
                let oldSc = sconto
                sconto = parseFloat(this.locRigaLotto.valore.importoNettoTotale) / (oldPl * qta)
                this.rielaboraSconti(oldSc, sconto)
                pl = parseFloat(this.locRigaLotto.valore.importoNettoTotale) / (sconto * qta)
              } else {
                // pl = parseFloat(this.locRigaLotto.valore.importoNettoTotale) * ( 1 + aliquota / 100) / (sconto * qta)
                pl = parseFloat(this.locRigaLotto.valore.importoNettoTotale) / (sconto * qta)
              }
              break;
            case 'valore.sconto1':
            case 'valore.sconto2':
            case 'valore.sconto3':
            case 'valore.sconto4':
              pl = parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario) || pl
              break;
            default:
              // pl = parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario) || pl
              break;
          }        
/*           this.locRigaLotto.valore.prezzoNettoUnitario = pl ? pl.toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoUnitario = pl ? (pl * ( 1 + aliquota / 100)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.prezzoUnitario)).toFixed(2) : '' */
          this.locRigaLotto.valore.prezzoNettoUnitario = pl ? pl : ''
          this.locRigaLotto.valore.prezzoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaLotto.valore.prezzoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoUnitario = pl ? (pl * ( 1 + aliquota / 100)) : ''
          this.locRigaLotto.valore.prezzoTotale = qta && pl ? +(qta * parseFloat(this.locRigaLotto.valore.prezzoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.prezzoNettoUnitario = pl ? +this.locRigaLotto.valore.prezzoNettoUnitario.toFixed(2) : ''
          this.locRigaLotto.valore.prezzoUnitario = pl ? +this.locRigaLotto.valore.prezzoUnitario.toFixed(2) : ''
          
/*           this.locRigaLotto.valore.importoNettoUnitario = pl ? (pl * sconto).toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoUnitario = pl ? ((pl * ( 1 + aliquota / 100)) * sconto).toFixed(2) : ''
          this.locRigaLotto.valore.importoTotale = qta && pl ? (qta * parseFloat(this.locRigaLotto.valore.importoUnitario)).toFixed(2) : '' */
          this.locRigaLotto.valore.importoNettoUnitario = pl ? (pl * sconto) : ''
          this.locRigaLotto.valore.importoNettoTotale = qta && pl ? +(qta * parseFloat(this.locRigaLotto.valore.importoNettoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoUnitario = pl ? ((pl * ( 1 + aliquota / 100)) * sconto) : ''
          this.locRigaLotto.valore.importoTotale = qta && pl ? +(qta * parseFloat(this.locRigaLotto.valore.importoUnitario)).toFixed(2) : ''
          this.locRigaLotto.valore.importoNettoUnitario = pl ? +this.locRigaLotto.valore.importoNettoUnitario.toFixed(2) : ''
          this.locRigaLotto.valore.importoUnitario = pl ? +this.locRigaLotto.valore.importoUnitario.toFixed(2) : ''
        }
      },
      rielaboraSconti(oldSc, sconto) {
        let sc1 = parseFloat(_.get(this.locRigaLotto,'valore.sconto1', 0) || '0')
        let sc2 = parseFloat(_.get(this.locRigaLotto,'valore.sconto2', 0) || '0')
        let sc3 = parseFloat(_.get(this.locRigaLotto,'valore.sconto3', 0) || '0')
        let sc4 = parseFloat(_.get(this.locRigaLotto,'valore.sconto4', 0) || '0')

        let newSc = 1
        if (sconto < oldSc) {
          sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
          _.set(this.locRigaLotto,'valore.sconto4', sc4.toFixed(2))
        } else {
          if (sc4) {
            sc4 = (1 - sconto/ ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100))) * 100
            if (sc4 < 0) sc4 = 0
              _.set(this.locRigaLotto,'valore.sconto4', sc4.toFixed(2))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc3) {
            sc3 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc4 / 100))) * 100
            if (sc3 < 0) sc3 = 0
              _.set(this.locRigaLotto,'valore.sconto3', sc3.toFixed(2))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)
          if (newSc < sconto && sc2) {
            sc2 = (1 - sconto / ((1 - sc1 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            if (sc2 < 0) sc2 = 0
              _.set(this.locRigaLotto,'valore.sconto2', sc2.toFixed(2))
          }
          newSc = (1 - sc1 / 100) * (1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100)                
          if (newSc < sconto && sc1) {
            sc1 = (1 - sconto / ((1 - sc2 / 100) * (1 - sc3 / 100) * (1 - sc4 / 100))) * 100
            // if (sc1 < 0) sc1 = 0 // Non cancello, se minore di zero è una Maggiorazione
              _.set(this.locRigaLotto,'valore.sconto1', sc1.toFixed(2))
          }
        }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
    td.articoliSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }

  .bodyTable .v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    padding: 0;
  }
</style>

<style scoped>
/*   .v-input, .v-label {
    font-size: 0.7em;
  } */
</style>